import { CheckoutCheckinOrder } from 'DataLayerAnalytics/types';
import { Diff } from './types';

const hasCountPropGuard = (object: any): object is { count: number } => {
	return object.hasOwnProperty('count');
};

abstract class BaseDiff {
	protected orderBeforeChange: CheckoutCheckinOrder;
	protected orderAfterChange: CheckoutCheckinOrder;

	constructor(orderBeforeChange: CheckoutCheckinOrder, orderAfterChange: CheckoutCheckinOrder) {
		this.orderBeforeChange = orderBeforeChange;
		this.orderAfterChange = orderAfterChange;
	}

	public getTravellersServicesDiff = <T extends {}>(
		beforeChange: T[],
		afterChange: T[],
		getId: (service: T) => string
	) => {
		const added: T[] = [];
		const removed: T[] = [];

		const beforeChangeMap: Map<string, T> = new Map();
		beforeChange?.forEach(service => beforeChangeMap.set(getId(service), service));

		const afterChangeMap: Map<string, T> = new Map();
		afterChange?.forEach(service => afterChangeMap.set(getId(service), service));

		afterChange?.forEach(afterChangeService => {
			const beforeChangeService = beforeChangeMap.get(getId(afterChangeService));

			if (!beforeChangeService) {
				added.push(afterChangeService);
			} else if (hasCountPropGuard(afterChangeService) && hasCountPropGuard(beforeChangeService)) {
				const after = afterChangeService;
				const before = beforeChangeService;

				if (after.count > before.count) {
					added.push({
						...after,
						count: after.count - before.count
					});
				} else if (after.count < before.count) {
					removed.push({
						...before,
						count: before.count - after.count
					});
				}
			}
		});

		beforeChange?.forEach(beforeChangeService => {
			const serviceAfterChange = afterChangeMap.get(getId(beforeChangeService));

			if (!serviceAfterChange) {
				removed.push(beforeChangeService);
			}
		});

		return { added, removed };
	};

	public abstract diff(): Diff;
}

export default BaseDiff;
